import React from 'react';
import { ScrollViewWithHeaderTitle, useBreakpointHelpers } from '@sg/garnish';

import {
  AvailableCredit,
  LoadingAnimation,
  useCustomerCredit,
} from '@order/components';

import type { CreditDetailsScreenProps } from '../../navigation/AppNavigation.props';

export const CreditDetailsScreen = ({
  navigation,
}: CreditDetailsScreenProps) => {
  const { isMobile } = useBreakpointHelpers();
  const { availableCredit, credits, isLoadingCredits } = useCustomerCredit();

  React.useLayoutEffect(() => {
    if (isMobile) return;
    navigation.getParent()?.goBack();
  }, [navigation, isMobile]);

  if (isLoadingCredits) return <LoadingAnimation />;

  return (
    <ScrollViewWithHeaderTitle testID="account.credit.root.container">
      <AvailableCredit creditAmount={availableCredit} creditDetails={credits} />
    </ScrollViewWithHeaderTitle>
  );
};
